import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("KLYROO render error:", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ minHeight: "100vh", background: "#090A0F", color: "#F8FAFC",
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          fontFamily: "sans-serif", padding: 24, textAlign: "center" }}>
          <div style={{ fontSize: 40, fontWeight: 800, letterSpacing: "-0.02em" }}>KLYROO</div>
          <p style={{ color: "#94A3B8", marginTop: 12 }}>Something went wrong loading this page.</p>
          <pre style={{ color: "#FF2A5F", fontSize: 12, maxWidth: 720, overflow: "auto", marginTop: 12 }}>
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <button onClick={() => window.location.reload()}
            style={{ marginTop: 20, padding: "10px 20px", borderRadius: 10, border: "none",
              background: "#00F0FF", color: "#000", fontWeight: 700, cursor: "pointer" }}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
